import { BaseQueryFn } from "@reduxjs/toolkit/query/react";
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { storageAvailable } from "../providers/LocalStorageProvider";
import { store } from "./store";

export interface ResponseData {
  code: string;
  message: string;
  element: any;
}

const AxiosService = axios.create();

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" }
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
      onUploadProgress?: any;
      signal?: AbortSignal;
    },
    ResponseData,
    AxiosError
  > =>
  async ({ url, method, data, params, headers, onUploadProgress, signal }) => {
    try {
      const result = await AxiosService({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
        onUploadProgress,
        signal
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError<ResponseData, any>;

      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message
        } as any
      };
    }
  };

export default axiosBaseQuery;

export const getToken = (): string | null => {
  const token = localStorage?.getItem(
    `${import.meta.env.VITE_STORAGE_PREFIX}_token`
  );

  if (token) {
    return token?.split(`"`).join("");
  }
  return null;
};

export const getSUMEntityToken = (): string | null => {
  let authPayload = null;
  if (storageAvailable("localStorage"))
    authPayload =
      localStorage.getItem(`LB_SUM_token_${store.getState().bots.wizard.id}`) ||
      "{}";
  const auth = {
    username: "",
    password: ""
  };
  if (authPayload) {
    const jsonAuthPayload = JSON.parse(authPayload);
    auth.username = jsonAuthPayload.userIdentification;
    auth.password = jsonAuthPayload.accessToken;
  }
  const authToken =
    auth.username && auth.password
      ? `Basic ${btoa(`${auth.username}:${auth.password}`)}`
      : "";

  if (authToken) {
    return authToken;
  }
  return null;
};
